import React, { createContext, useContext, useState, useCallback } from 'react';
import { loginApi } from '@/lib/api';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(() => {
    const token = localStorage.getItem('token');
    const username = localStorage.getItem('username');
    const role = localStorage.getItem('role') || 'admin';
    return token && username ? { username, token, role } : null;
  });

  const login = useCallback(async (username, password) => {
    const res = await loginApi(username, password);
    const { access_token, username: uname, role } = res.data;
    localStorage.setItem('token', access_token);
    localStorage.setItem('username', uname);
    localStorage.setItem('role', role || 'admin');
    setUser({ username: uname, token: access_token, role: role || 'admin' });
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem('token');
    localStorage.removeItem('username');
    localStorage.removeItem('role');
    setUser(null);
  }, []);

  return (
    <AuthContext.Provider value={{ user, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
